export const datadogSample = {
    'id': '5319231376948593867',
    'email': 'alertnow.mobile@opsnow.com',
    'eventTitle': '[Triggered on {host:SEOUL-A-DEV-BESPINMD-DASHBOARD-WAS01}] CPU Alarm',
    'eventMsg': '%%%@slack-notifs-datadog-mgmt @slack-srph-mgmt-t1-notif%%%',
    'textOnlyMsg': '@slack-notifs-datadog-mgmt @slack-srph-mgmt-t1-notif `avg(last_5m):avg:aws.applicationelb.healthy_host_count{app:prd-anl-alb} by {region,targetgroup}.rollup(max) ',
    'eventType': 'query_alert_monitor',
    'date': '1581313762000',
    'datePosix': '1581313762',
    'alertId': '10319960',
    'alertType': 'error',
    'aggregKey': '39fe3b5b5fbc974fc5dece876da01502',
    'orgId': '186692',
    'alertStatus': 'avg(last_1m):avg:system.cpu.user{*} by {host} > 10',
    'alertScope': 'host:SEOUL-A-DEV-BESPINMD-DASHBOARD-WAS01',
    'hostname': 'SEOUL-A-DEV-BESPINMD-DASHBOARD-WAS01',
    'user': '10061',
    'username': 'woosung.lee',
    'snapshot': 'https://p.datadog.com/snapshot/view/dd-snapshots-prod/org_186692/2020-02-10/berlwkj230103kdglwjrlnalqjtlkd.png',
    'link': 'https://app.datadog.com/event/event?id=5319231323423467',
    'priority': 'normal',
    'tags': 'host:seoul-a-dev-bespinmd-dashboard-was01,monitor',
    'lastUpdated': '',
    'lastUpdatedPosix': '',
    'alertMetric': 'system.cpu.user 544f61ab-60b3-4dd4-beb9-a18e983e5761',
    'metricNamespace': 'system',
    'alertTransition': 'Triggered',
    'orgName': 'Bespinglobal',
    'alertQuery': 'avg(last_1m):avg:system.cpu.user{*} by {host} > 10',
    'alertTitle': 'CPU Alarm on host:SEOUL-A-DEV-BESPINMD-DASHBOARD-WAS01',
    'alertCycleKey': '5319231378341102797'
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/datadog.ts